export default __webpack_public_path__ + "icon-stumbler@2x.96c93a53.png";